import { render, staticRenderFns } from "./tableau-scores.vue?vue&type=template&id=c1503168&"
import script from "./tableau-scores.vue?vue&type=script&lang=js&"
export * from "./tableau-scores.vue?vue&type=script&lang=js&"
import style0 from "./tableau-scores.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports